// Working & & use "import FocusInserted from './FocusInsertedDirective"
export default {
  inserted(el, binding, vnode) {
    // const shouldFocus = binding.value === undefined || (binding.value && binding.value.focus)
    // if (!shouldFocus) return
    if (binding.value === undefined || (binding.value && binding.value.focus)) {
      el.focus()
    }
  }
}
